export default function getCurrentLanguage() {
    return localStorage.getItem('currentLanguage') || 'en';
}
